import React, {useEffect, useState} from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import {styleVars} from "../../app-style-vars";
import PtText from "./pt-text/pt-text";

export default function PtRadioButtons(props:any) {
  const buttons = props.buttons || [];
  const initialValue = props.initialValue || '';
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    /** we only need to do this if state is maintained on some upper level component and passed down via initialValue prop */
    if(props.valueChangedHandler) {
      setValue(initialValue)
    }
  })

  const toggleCheck = (val:any, label:any) => {
    if(props.valueChangedHandler) {
      props.valueChangedHandler({newValue: val, newLabel: label})
    } else {
      setValue(val);
    }
  }

  return (
    <View style={[styles.radioButtonsContainer]}>
      {props.title ?
        <View style={[styles.radioButtonsGroupTitle]}>
          <PtText style={[styles.radioButtonsGroupTitleText]}>{props.title}</PtText>
        </View>
        : null
      }

      <View style={[styles.buttonsContainer]}>
        {buttons.map((button:any, idx:number) => (
          <TouchableOpacity onPress={() => toggleCheck(button.value, button.label)} key={idx}>
            <View style={[styles.radioButtonContainer]}>
              <View style={[styles.radioButtonIcon]}>
                {button.value == value ? <View style={[styles.radioButtonIconInner]}/> : null }
              </View>
              <View style={[styles.radioButtonLabel]}>
                <PtText style={[styles.radioButtonLabelText]}>
                  {button.label}
                </PtText>
              </View>
            </View>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  )

}

const styles = StyleSheet.create({
  radioButtonsContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  radioButtonsGroupTitle: {
    paddingLeft: styleVars.rem(.5),
  },
  radioButtonsGroupTitleText: {
    fontSize: styleVars.rem(1),
    fontWeight: '600',
  },
  radioButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: styleVars.rem(2),
  },
  buttonsContainer:{
    paddingHorizontal: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.5),
  },
  radioButtonIcon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: styleVars.boschLightGrayW75,
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioButtonIconInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: styleVars.boschDarkBlue,
  },
  radioButtonLabel: {
    paddingLeft: styleVars.rem(.5)
  },
  radioButtonLabelText: {
    fontSize: styleVars.rem(.75),
    fontWeight: '600'
  }
})